
import { CONSTANTS } from "../../constants";
import { getCollections } from "../../services";
export default {
  async asyncData({ redirect }) {
    try {
      const blogs = [];
      const allTags = [];

      const resp = await getCollections(
        `${CONSTANTS.BLOG_API_ENDPOINT}/api/categories?populate=posts.author.avatar,posts.tags,posts.coverImage`,
        CONSTANTS.BLOG_API_KEY
      );
      if (!resp) redirect(404, "/error");
      resp?.forEach(({ attributes: categoryAttr }) => {
        if (categoryAttr?.posts?.data?.length) {
          const layoutObj = {
            categoryName: categoryAttr.name,
            categorySlug: categoryAttr.slug,
            posts: [],
          };
          const postList = categoryAttr.posts.data;
          postList.sort(({ attributes: post1 }, { attributes: post2 }) => {
            const date1 = new Date(post1.createdAt),
              date2 = new Date(post2.createdAt);
            if (date1 < date2) {
              return 1;
            } else if (date1 > date2) {
              return -1;
            } else {
              return 0;
            }
          });
          postList.forEach(({ attributes }) => {
            const tags = attributes?.tags.data.map((tag) => {
              if (!allTags.includes(tag.attributes.name))
                allTags.push(tag.attributes.name);
              return tag.attributes.name || [];
            });
            const imgFormats = attributes?.coverImage.data?.attributes.formats;
            const imageUrl =
              imgFormats?.medium?.url ||
              imgFormats?.small?.url ||
              imgFormats?.thumbnail?.url ||
              imgFormats?.large?.url;
            const article = {
              title: attributes?.title,
              snippet: attributes?.description,
              slug: attributes?.slug,
              image: `${CONSTANTS.BLOG_API_ENDPOINT}${imageUrl}`,
              category: layoutObj.categoryName,
              tags,
            };
            layoutObj.posts.push(article);
          });
          blogs.push(layoutObj);
        }
      });
      return {
        blogs,
        topics: allTags,
      };
    } catch (e) {
      console.log(e);
    }
  },

  head() {
    return {
      title: "Blogs | AiBuddha",
      // templateTitle: "%title%",
      description:
        "Discover Insights and Inspirations to improve your business with our blogs",
      url: "https://aibuddha.in/blogs",
      image: "https://aibuddha.in/images/aibuddha-blogs.png",
      openGraph: {
        image: {
          url: "https://aibuddha.in/images/aibuddha-blogs.png",
          alt: "Blogs | AiBuddha",
        },
        site: "@aibuddha",
        creator: "@aibuddha",
        title: "Blogs | AiBuddha",
        description:
          "Discover Insights and Inspirations to improve your business with our blogs",
        url: "https://aibuddha.in/",
      },
      keywords: `${this.blogs
        .map(({ categoryName }) => categoryName)
        .join(",")},${this.topics.join(",")},aibuddha,blogs`,
    };
  },
  data() {
    return {
      selectedTopics: [],
      lastSearchedTopic: [],
    };
  },
  methods: {
    setSelectedTopics(topics) {
      this.selectedTopics = topics;
    },
  },
  computed: {
    filteredBlog() {
      const topics = this.selectedTopics;
      if (topics.length === 0) return (this.lastSearchedTopic = []);
      this.lastSearchedTopic = topics;
      const newBlogList = [];
      this.blogs.forEach(({ posts }) => {
        const filteredPosts = posts.filter(({ tags }) =>
          tags.some((tag) => topics.includes(tag))
        );
        newBlogList.push(...filteredPosts);
      });
      newBlogList.sort((post1, post2) => {
        const date1 = new Date(post1.createdAt),
          date2 = new Date(post2.createdAt);
        if (date1 < date2) {
          return 1;
        } else if (date1 > date2) {
          return -1;
        } else {
          return 0;
        }
      });
      return newBlogList || [];
    },
  },
};
